import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { ElvaWork } from '../ElvaWork';

export function ElvaWorkPage({ view }: { view: 'report' | 'log' }) {
  usePageTopBar({ breadcrumb: ['ELVA’s work'], hideTopBar: true });
  return <ElvaWork view={view} />;
}
